module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "posts"
  }, [_c('ui-module-header', {
    attrs: {
      "title": "Posts",
      "icon": "inbox"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transitionName,
      "mode": _vm.transitionMode
    },
    on: {
      "enter": _vm.$defaultEnterTransition
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-363113f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modules/Post/Post.vue
// module id = 267
// module chunks = 2